import { createApp } from 'vue'

//导入PC适配JS(H5)
//#ifdef H5
import "./adaptation.js"
//#endif

import App from './App.vue'
import router from './router'
import 'vant/lib/index.css' //引入Vant的样式文件
import '@vant/touch-emulator';
import '@/assets/icon_font/iconfont.css';//引入iconfont
import vant from 'vant' 
//引入Vant库

// createApp(App).use(router).mount('#app')

const app = createApp(App)
app.use(router) //注册路由

app.use(vant).mount('#app') 
//使用Vant库并挂载到Vue实例